import { useAppSelector } from "redux-share";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName, IMarkerListIconProps } from "../../../../../interfaces";
import { shallowEqual } from "react-redux";

const MarkersListIcon = (props: IMarkerListIconProps) => {
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    let icon = <></>;

    if (conditions(ConditionName.isSplusEnvironment))
        icon = (
            <i
                className={`fa-solid fa-list pl-text-white pl-cursor-pointer ${
                    conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                        ? controllbarIconSize.otherFontAwesome
                        : controllbarIconSize.miniPlayerFontAwesome
                }`}
                onMouseOver={props.onMouseOver}
                onMouseLeave={props.onMouseLeave}
                onClick={props.onClick}
            />
        );
    else
        icon = (
            <svg
                width={
                    conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                        ? controllbarIconSize.other
                        : controllbarIconSize.miniPlayer
                }
                height={
                    conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                        ? controllbarIconSize.other
                        : controllbarIconSize.miniPlayer
                }
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <rect x="3" y="3" width="4" height="4" rx="1.5" />
                <rect x="3" y="9" width="4" height="4" rx="1.5" />
                <rect x="3" y="15" width="4" height="4" rx="1.5" />
                <rect x="8" y="16" width="11" height="2" rx="1" />
                <rect x="8" y="10" width="11" height="2" rx="1" />
                <rect x="8" y="4" width="11" height="2" rx="1" />
            </svg>
        );

    if (conditions(ConditionName.isComplexPortrait))
        icon = (
            <div
                className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer"
                onClick={props.onClick}
            >
                {icon}
                <span>نشانگرها</span>
            </div>
        );

    return <>{icon}</>;
};

export default MarkersListIcon;
